import { EmailTemplate } from "../../types/EmailTemplate";

/**
 * Données fictives de l'aperçu (reprennent la maquette "Taux de transfert") :
 * 10 pays de départ × 9 destinations, 425 fcfa de taux et 0 fcfa de frais.
 */
const PREVIEW_COUNTRIES = [
  "Afrique du Sud",
  "Bénin",
  "Burkina Faso",
  "Cameroun",
  "Canada",
  "Chine",
  "Côte d’Ivoire",
  "Gabon",
  "RD Congo",
  "Togo",
];

const PREVIEW_RATE_GROUPS = PREVIEW_COUNTRIES.map((sender) => ({
  senderName: sender,
  items: PREVIEW_COUNTRIES.filter((destination) => destination !== sender).map((destination) => ({
    senderName: sender,
    destinationName: destination,
    rateLabel: "425 fcfa",
    feesLabel: "0 fcfa",
  })),
}));

/**
 * Modèle "Taux du jour".
 * À l'envoi, le tableau des taux est chargé depuis l'API (voir enrichTemplateDataAsync
 * dans utils/templateDataEnricher.ts). L'aperçu utilise les données fictives ci-dessus.
 */
export const TemplateDailyRates: EmailTemplate = {
  id: "daily-rates",
  name: "Taux du jour",
  description: "Les taux d'envoi du jour par corridor, chargés automatiquement",
  templateFile: "daily-rates",
  previewData: {
    title: "Taux de transfert",
    message:
      "<p>Voici les taux d'envoi applicables aujourd'hui pour vos transferts.</p><p>Envoyez en quelques secondes depuis l'application, au meilleur taux.</p>",
    dateLabel: "04 Novembre 2026",
    rateGroups: PREVIEW_RATE_GROUPS,
  },
  fields: [
    {
      name: "title",
      label: "Titre",
      type: "text",
      required: true,
      defaultValue: "Taux de transfert",
      placeholder: "Ex: Taux de transfert",
    },
    {
      name: "message",
      label: "Message d'introduction",
      type: "textarea",
      required: false,
      placeholder: "Ex: Voici les taux d'envoi applicables aujourd'hui...",
    },
    {
      name: "ctaText",
      label: "Texte du bouton (optionnel)",
      type: "text",
      required: false,
      placeholder: "Ex: Envoyer maintenant",
    },
    {
      name: "ctaUrl",
      label: "Lien du bouton (optionnel)",
      type: "url",
      required: false,
      placeholder: "https://izilifepay.com",
    },
    {
      name: "kafintechLogo",
      label: "Logo Kafintech — lien de l'image (optionnel)",
      type: "url",
      required: false,
      placeholder: "https://.../kafintech-logo.png",
    },
    {
      name: "disclaimer",
      label: "Mention en bas de mail (optionnel)",
      type: "text",
      required: false,
      placeholder: "Par défaut : les taux sont donnés à titre indicatif...",
    },
  ],
};
